<div class="dialog-wrapper">
    <nb-card class="dialog-card fullWidth" kveDialogBackdrop>
        <nb-card-header>
           <div class="title">Edit Section: {{section?.sectionId}}<span class="title-info">[{{rendererType | rendererTypeNormalizer}}]</span></div>
            <div class="action">
                <nb-actions size="tiny">
                    <nb-action title="Snapshot" (click)="snapShot($event)">
                        <nb-icon class="toggle-icon" icon="camera-outline" pack="eva">Photo</nb-icon>
                    </nb-action>
                    <nb-action title="Export" (click)="export($event)">
                        <nb-icon class="toggle-icon" icon="code-download-outline" pack="eva">Save</nb-icon>
                    </nb-action>
                    <nb-action title="Save" (click)="onSave($event)">
                        <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                    </nb-action>
                    <nb-action>
                        <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                    </nb-action>
                </nb-actions>
            </div> 
        </nb-card-header>
        <div class="layout-container">
            <nb-sidebar class="editor-sidebar" state="compacted" tag="sectionEditorSideBar">
                <nb-menu [items]="sectionDialogMenuItems" tag="sectionEditorMenu" autoCollapse="false" kveMenuItemPopover></nb-menu>
            </nb-sidebar>
        <!-- <nb-card-body> -->
            <div class="content">
                <div class="columns">
                    <div class="preview-editor-container">
                        <kve-section-preview></kve-section-preview>
                    </div>
                </div>
            </div>
           <!--  <div class="editor-wrapper">
                <div  class="editor-input-group preview">
                    <div class="edit-options">
                        <ng-container [ngSwitch]="sectionData.rendererType | rendererTypeNormalizer">
                            <ng-container *ngSwitchCase="'grid'">
                                <kve-grid-options [sectionData]="sectionData"></kve-grid-options>
                            </ng-container>
                            <ng-container *ngSwitchCase="'banner'">
                                <kve-banner-section-options [sectionData]="sectionData"></kve-banner-section-options>
                            </ng-container>
                            <ng-container *ngSwitchCase="'rich-text'">
                                <kve-richtext-options [sectionData]="sectionData"></kve-richtext-options>
                            </ng-container>
                            <ng-container *ngSwitchCase="'row'">
                                <kve-row-options [sectionData]="sectionData"></kve-row-options>
                            </ng-container>
                            <ng-container *ngSwitchCase="'hero-image'">
                                <kve-hero-image-options [sectionData]="sectionData"></kve-hero-image-options>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <kve-section-options [sectionData]="sectionData"></kve-section-options>
                            </ng-container>         
                        </ng-container>
                    </div>
                </div>
                <div class="editor-input-group">
                    <div class="step-info">Font</div>
                    <div class="input-wrapper">
                        <nb-actions size="tiny">
                            <nb-action class="popover-icon"
                                [nbPopover]="fontSizePop" 
                                [nbPopoverContext]="{title:'Font Size',headers:headers,content:selectedContent,target:'self',declaration:'fontSize'}" 
                                nbPopoverPlacement="top">
                                <svg viewBox="0 0 24 24" id="ic_title_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M5 4v3h5.5v12h3V7H19V4z" />
                                </svg>
                            </nb-action>
                            <nb-action title="Font Family"
                                class="popover-icon"
                                [nbPopover]="fontFamPop" 
                                [nbPopoverContext]="{title:'Font Family',fontFams:fontFams,content:selectedContent,target:'self',declaration:'fontFamily'}">
                                <svg viewBox="0 0 24 24" id="ic_format_shapes_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"/>
                                </svg>
                            </nb-action>
                            <nb-action title="Text Color"
                                class="popover-icon"
                                [nbPopover]="component" 
                                [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,service:'sectionEditStore',property:'color'}" nbPopoverPlacement="top">
                                <svg viewBox="0 0 24 24" id="ic_format_color_text_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path fill-opacity=".36" d="M0 20h24v4H0z" />
                                    <path d="M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z" />
                                </svg>
                            </nb-action>
                            <nb-action>H Align:</nb-action>
                            <nb-action title="H Align Left" (click)="setHorizontalAlign('justify-left')" class="popover-icon">
                                <svg viewBox="0 0 24 24" id="ic_format_align_left_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z" />
                                </svg>
                            </nb-action>
                            <nb-action title="H Align Center" (click)="setHorizontalAlign('justify-center')" class="popover-icon">
                                <svg viewBox="0 0 24 24" id="ic_format_align_center_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z" />
                                </svg>
                            </nb-action>
                            <nb-action title="H Align Right" (click)="setHorizontalAlign('justify-right')" class="popover-icon">
                                <svg viewBox="0 0 24 24" id="ic_format_align_right_24px" width="100%" height="100%" fill="var(--actions-icon-color)">
                                    <path d="M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z" />
                                </svg>
                            </nb-action>
                            <nb-action>
                                <nb-select [(selected)]="selectedFontFam" [placeholder]="selectedFontFam"  (selectedChange)="onChangeFontFam($event)" size="tiny" [ngStyle]="{'width':'20rem'}">
                                    <nb-option *ngFor="let fontFam of fontFams" [value]="fontFam" [ngStyle]="{'font-family':''+fontFam.value+''}">{{ title?.text }}</nb-option>
                                </nb-select>
                            </nb-action>
                        </nb-actions>
                    </div>
                </div>
                <div class="editor-input-group">
                    <div class="step-info">Section</div>
                    <div class="input-wrapper">
                        <nb-actions size="tiny">
                            <nb-action>
                                <button nbButton size="tiny" [nbPopover]="sliderPop" [nbPopoverContext]="{marginBottom:marginBottom,title:'Section Margin Bottom',target:'marginBottom',height:'400px'}" nbPopoverPlacement="top">Margin Bottom</button>
                            </nb-action>
                            <nb-action>Fill:</nb-action>
                            <nb-action>None</nb-action>
                            <nb-action>Solid</nb-action>
                            <nb-action>Gradient</nb-action>
                            <nb-action>Radial</nb-action>
                        </nb-actions>
                    </div>    
                </div>

            </div> -->
            <!-- <div class="editor-preview">
                <div class="preview-wrapper">
                    <div class="preview-header">Preview</div>
                    <div class="preview-content">
                        <kw-rich-text-renderer [data]="sectionData"></kw-rich-text-renderer>
                    </div>
                </div>
            </div> -->
            <!-- </nb-card-body> -->
        </div>
        
        
        <!-- <div class="parent-selectors">
    
                <nb-action>
                    <button nbButton size="tiny" [nbPopover]="component" [nbPopoverContext]="{color:textColor,colors:fillColors,content:selectedContent,target:'parent',property:'background'}" nbPopoverPlacement="left">Background</button>
                </nb-action>
                <nb-action>Vertical Align:</nb-action>
                <nb-action [ngStyle]="{'min-width':'8 rem'}">
                    <nb-select [(selected)]="selectedContainerLayout" [placeholder]="selectedContainerLayout"  (selectedChange)="onChangeContainerLayout($event)" size="tiny" class="action-select">
                        <nb-option *ngFor="let containerLayout of containerLayouts" [value]="containerLayout">{{ containerLayout.name }}</nb-option>
                    </nb-select>
                </nb-action>
                <nb-action>Horisontal Align:</nb-action>
                <nb-action [ngStyle]="{'min-width':'8 rem'}">
                    <nb-select [(selected)]="selectedAlignment" [placeholder]="selectedAlignment"  (selectedChange)="onChangeAlign($event)" size="tiny" class="action-select">
                        <nb-option *ngFor="let alignment of alignments" [value]="alignment">{{ alignment.name }}</nb-option>
                    </nb-select>
                </nb-action>
                <nb-action>
                    <button nbButton size="tiny">Border</button>
                </nb-action>
    
        </div>  -->
    </nb-card>
</div>

